import { Grid } from "@mantine/core";
import { IRootState } from "config/redux";
import { AuthorityConstants, ServiceConstants } from "constant";
import { TFunction } from "i18next";
import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { CreditService } from "services";
import { CreditResponse, CreditRequestAttachmentsResponse} from "types";
import { AppUtils, UserUtils } from "utils";
import CreditRequiredDocumentation from "./types/list";
import CreditDeliveredDocumentation from "./attachments";

const { ROLE_CC_C, ROLE_CC_U } = AuthorityConstants;
const { REQUEST_CREDIT_ATTACHMENT_LIST_ID, REQUEST_PENDING } = ServiceConstants;

interface CreditDocumentationProps {
  credit: CreditResponse;
  t: TFunction;
}

const CreditDocumentation = ({ credit, t }: CreditDocumentationProps) => {

  const attachmentServiceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CREDIT_ATTACHMENT_LIST_ID]);
  const [documentation, setDocumentation] = useState<CreditRequestAttachmentsResponse | undefined>(undefined);

  useEffect(() => {
    if (credit) CreditService.creditAttachments(credit.id);
  }, [credit]);

  useEffect(() => {
    AppUtils.resolveServiceObject(attachmentServiceObject, REQUEST_CREDIT_ATTACHMENT_LIST_ID, setDocumentation)
  } ,[attachmentServiceObject]);

  const isLoading = useMemo(() => attachmentServiceObject && attachmentServiceObject.status === REQUEST_PENDING,[attachmentServiceObject]);

  const isNewAllowed = useMemo(() =>
    UserUtils.hasAnyAuthority([ROLE_CC_C, ROLE_CC_U])
    && (
      credit.status === 'DRAFT'
      || credit.status === 'PROCESSING'
      || credit.status === 'APPROVED'
      || credit.status === 'SIGNING'
      || credit.status === 'SIGNED_INCOMPLETE'
      || credit.status === 'SENT_TO_BANK'
    )
    && credit.requestedAt
  , [credit]);

  return (
    <Grid px={'md'} grow={true}>
      <Grid.Col span={{ xs: 12, sm: 12, md: 12, lg: 5 }}>
        <CreditRequiredDocumentation
          credit={credit}
          t={t}
          types={documentation?.types}
          loading={isLoading}
          isNewAllowed={isNewAllowed}
        />
      </Grid.Col>
      <Grid.Col span={{xs: 12, sm: 12, md: 12, lg: 7 }}>
        <CreditDeliveredDocumentation
          credit={credit}
          t={t}
          attachments={documentation?.attachments}
          loading={isLoading}
          isNewAllowed={isNewAllowed}
        />
      </Grid.Col>
    </Grid>
  )
}

export default CreditDocumentation;